import React from "react";
import {
  SEO,
  PageLayout,
  MarkdownContent,
  InternalLink,
  FishermanIcon,
  FadeReveal,
  SlideReveal,
  multipleComponentIterator,
  HoverContainer,
  BasicCarousel,
  Image,
  TeamMemberV2,
} from "@bluefin/components";
import { Grid, Header, Button, List } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";
import { createTeamMemberSlug } from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class AboutPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      allFishermanBusinessTeam,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogUrl={"https://www.vibesalon.com/about/"}
        />
        <PageLayout hero={false} subfooter={false} className={"about-page"}>
          <Grid
            className={"about-hero-container"}
            stackable={true}
            textAlign={"center"}
          >
            <Grid.Column width={16}>
              <Header as={"h1"}>
                <span
                  className={"no-highlight"}
                  children={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "about_header",
                    defaultValue: "About",
                  })}
                />
                <span
                  className={"highlight"}
                  children={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "about_header_highlighted",
                    defaultValue: "",
                  })}
                />
              </Header>
              <MarkdownContent
                className={"about-header-description"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "about_header_description",
                })}
              />
              <div className={"hero-action-buttons"}>
                <Button
                  id={"navigate-down-arrow"}
                  className={"navigate-down-arrow"}
                  to={"#navigate-down-arrow"}
                  as={InternalLink}
                  icon={true}
                  aria-label={"Scroll Down to Next Section"}
                >
                  <FishermanIcon iconName={"arrow-down"} />
                </Button>
              </div>
            </Grid.Column>
          </Grid>
          <Grid
            className={"about-content-container"}
            stackable={true}
            textAlign={"center"}
          >
            <Grid.Column
              width={12}
              textAlign={"left"}
              className={"markdown-column"}
            >
              <FadeReveal duration={1250} triggerOnce={true}>
                <MarkdownContent
                  className={"about-description"}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "about_description",
                  })}
                />
              </FadeReveal>
            </Grid.Column>
          </Grid>
          <Grid stackable={true} className={"featured-stylists-list-container"}>
            <Grid.Column width={16}>
              <Header
                as={"h2"}
                className={"main-header"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "staff_section_header",
                  defaultValue: "OUR TEAM",
                })}
              />
              <MarkdownContent
                className={"about-staff-description"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "staff_section_description",
                })}
              />
              <List>
                <SlideReveal
                  cascade={true}
                  triggerOnce={true}
                  direction={"up"}
                  fade={true}
                  children={multipleComponentIterator({
                    iterator: allFishermanBusinessTeam.nodes,
                    limit: 4,
                    components: [
                      {
                        component: (
                          <HoverContainer
                            displayOnTouchScreen={false}
                            forceDisplay={true}
                          />
                        ),
                        propMap: { key: "_id" },
                        children: [
                          {
                            component: (
                              <List.Item
                                className={"featured-stylist-item"}
                                event={{
                                  category: "Team",
                                  action: "View Team Member",
                                }}
                                as={InternalLink}
                              />
                            ),
                            propMap: {
                              to: createTeamMemberSlug,
                              "event.label": "name",
                            },
                            children: [
                              {
                                component: (
                                  <Grid
                                    className={"item-internal"}
                                    stackable={true}
                                  />
                                ),
                                children: [
                                  {
                                    component: (
                                      <Grid.Column
                                        width={10}
                                        textAlign={"left"}
                                        className={"staff-name-column"}
                                      />
                                    ),
                                    children: [
                                      {
                                        component: (
                                          <div className={"staff-name"} />
                                        ),
                                        propMap: { children: "name" },
                                      },
                                      {
                                        component: (
                                          <FishermanIcon iconName={"plus"} />
                                        ),
                                      },
                                    ],
                                  },
                                  {
                                    component: (
                                      <Grid.Column
                                        width={6}
                                        className={"staff-role-column"}
                                      />
                                    ),
                                    children: [
                                      {
                                        component: (
                                          <span
                                            className={"staff-role-and-social"}
                                          />
                                        ),
                                        children: [
                                          {
                                            component: (
                                              <span className={"staff-role"} />
                                            ),
                                            propMap: { children: "role" },
                                          },
                                          {
                                            component: (
                                              <span
                                                className={"staff-social"}
                                              />
                                            ),
                                            children: [
                                              {
                                                component: (
                                                  <HoverContainer.Content />
                                                ),
                                                children: [
                                                  {
                                                    component: (
                                                      <TeamMemberV2.Social
                                                        linked={false}
                                                      />
                                                    ),
                                                    propMap: {
                                                      social: "socialMedia",
                                                    },
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  })}
                />
              </List>
              <Button
                to={"/team/"}
                primary={true}
                event={{ category: "Team", action: "View All Team Members" }}
                as={InternalLink}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "see_all_team_button",
                  defaultValue: "See Our Team",
                  enforceDefault: true,
                })}
              />
            </Grid.Column>
          </Grid>
          <div className={"home-page"}>
            <div className={"image-gallery-section"}>
              <BasicCarousel
                className={"image-gallery stretched-carousel"}
                size={2}
                displayIndicators={false}
                displayPlayPauseButton={false}
                autoScroll={false}
                tablet={{}}
                mobile={{}}
                animation={{
                  name: "blur",
                  duration: 200,
                  transitionProps: {
                    preAnimating: { opacity: 0.99, blur: "2px" },
                    animating: { opacity: 0.99, blur: "2px" },
                  },
                }}
                items={[
                  <Image
                    key={"1"}
                    background={true}
                    src={
                      "https://fisherman.gumlet.io/public/c0871390-5204-45aa-b020-d3e1115f48e0/mms_attachment_6_xLehOrM.jpg"
                    }
                  />,
                  <Image
                    key={"2"}
                    background={true}
                    src={
                      "https://fisherman.gumlet.io/public/c0871390-5204-45aa-b020-d3e1115f48e0/mms_attachment_5_pi0wuUU.jpg"
                    }
                  />,
                  <Image
                    key={"3"}
                    background={true}
                    src={
                      "https://fisherman.gumlet.io/public/c0871390-5204-45aa-b020-d3e1115f48e0/mms_attachment_7_W7Jjhx5.jpg"
                    }
                  />,
                ]}
              />
            </div>
          </div>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(pageType: { eq: "About" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
        }
        contentNodes {
          content
        }
      }
      seoTitle
    }
    allFishermanBusinessTeam(
      sort: { order: ASC, fields: order }
      filter: { show: { eq: true } }
    ) {
      nodes {
        _id
        name
        role
        group
        email
        phone
        description
        image
        gatsbyImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        socialMedia {
          platform
          url
        }
        hours {
          startDay
          openTime
          closeTime
        }
        locations {
          _id
          name
        }
        show
      }
    }
  }
`;
